import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { logInSelector, signinSelector } from "../../../../selectors/signin";
import { signInRequest, setRecoverPassword } from "../../../../actions/signin";
import {
  getLoginRequest,
  postLoginRequest,
  cleanLogin,
} from "../../../../actions/login";
import FormLogin from "./FormLogin";
import { companySelector } from "../../../../../app/selectors/company";
import { setView } from "../../../../actions/view";

const mapStateToProps = createStructuredSelector({
  companyStore: companySelector,
  signInStore: signinSelector,
  loginStore: logInSelector,
});

const mapDispatchToProps = {
  signInRequest,
  getLoginRequest,
  cleanLogin,
  postLoginRequest,
  setRecoverPassword,
  setView,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormLogin);
